module.exports = __webpack_public_path__ + "static/media/mobileScreenshot04.0e60ea63.jpg";